$(window).on('load resize', fullWidth);

function fullWidth() {
    var $elements = $('body:not(.mxm_unigrid-editmode) .row-fullwidth');

    $.each($elements, function (key, item) {
        var $el = $(this);
        var offset = $el.parent().offset().left;

        $el.css({
            left: -offset,
            position: "relative",
            width: $(window).innerWidth() 
        });
    });
}